// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1h_2s","footer":"Form_footer__3zslj"};